import React from 'react';

// Data for all the ways to support Snehwan.
// Each entry has a title + list of items (title + description),
// so we can map over this instead of repeating JSX for every section.
const donationSections = [
  {
    title: '1. Financial Contributions & Sponsorship',
    items: [
      {
        heading: 'Child Sponsorship',
        text: "Direct financial support helps cover the comprehensive residential, nutritional, and educational needs of a child at the Swami Vivekanand Dnyanalaya residential project. Sponsoring one child costs ₹80,000/- per year, which covers all expenses including education, food, shelter, health, and other general needs.",
      },
      {
        heading: 'Sponsor a Meal',
        text: 'Supporters can sponsor meals on special occasions—such as birthdays, anniversaries, festivals, or memorial days—to share joy and provide nutritious food for the children. Sponsoring a one-time meal for 100 children costs ₹10,000/-, or you can sponsor a full day\'s meals for ₹20,000/-.',
      },
      {
        heading: 'General Donations',
        text: 'Contributions of any size help sustain daily operations, including nutritious meals, clothing, healthcare, and facility maintenance.',
      },
      {
        heading: 'Platform Giving',
        text: "Donations can be securely processed through the account details given on the official Snehwan website.",
      },
    ],
  },
  {
    title: '2. Nutrition & Dairy Support',
    items: [
      {
        heading: 'Dairy Cow Shed Expenses',
        text: "Contributions toward dairy operations help maintain the cow shed, ensuring a consistent and healthy supply of fresh, wholesome milk for the children's daily nutrition and balanced growth.",
      },
    ],
  },
  {
    title: '3. Daily Needs & Material Support',
    items: [
      {
        heading: 'Groceries & Food Staples',
        text: 'Grains, pulses, cooking essentials, and fresh produce.',
      },
      {
        heading: 'Medicines & Healthcare',
        text: 'First-aid items, routine medicines, and health supplements.',
      },
      {
        heading: 'Educational Supplies',
        text: 'Notebooks, textbooks, stationery, and learning aids.',
      },
      {
        heading: 'Digital Equipment',
        text: 'Computers, laptops, tablets, and accessories to support digital literacy and online learning.',
      },
    ],
  },
  {
    title: '4. Support Our Running & Infrastructure Projects',
    items: [
      {
        heading: 'General Contributions',
        text: 'Direct funding toward active day-to-day operations and ongoing community welfare initiatives.',
      },
      {
        heading: 'Build a School',
        text: "Contributing to the construction, expansion, and modernization of school buildings, classrooms, and residential facilities to create a safer and more equipped learning environment for the children.",
      },
      {
        heading: '"Land for Dream" Campaign',
        text: "Supporting land acquisition efforts to secure a permanent, expansive campus and a stable foundation for the children's long-term growth and future development.",
      },
    ],
  },
  {
    title: '5. Volunteering & Skill Sharing',
    items: [
      {
        heading: 'Academic & Technical Mentorship',
        text: 'Volunteers can contribute their time to teach core subjects (such as mathematics and science) or guide students at the fully functional computer education center.',
      },
      {
        heading: 'Extracurricular Training',
        text: 'Support is welcomed in specialized areas like yoga, music, arts, sports, agriculture, and vocational life skills to foster overall youth development.',
      },
    ],
  },
  {
    title: '6. Corporate Partnerships & CSR',
    items: [
      {
        heading: 'CSR Initiatives',
        text: 'Companies can partner with Snehwan under Corporate Social Responsibility programs to fund infrastructure projects, educational supplies, or technology upgrades.',
      },
      {
        heading: 'Institutional Support',
        text: 'Educational institutions and businesses can organize awareness drives, employee engagement programs, or donation campaigns to support the cause.',
      },
    ],
  },
  {
    title: '7. Spreading Awareness & Community Fundraising',
    items: [
      {
        heading: 'Digital Advocacy',
        text: "Following, engaging with, and sharing Snehwan's updates across social media channels (such as LinkedIn, Instagram, Facebook, and YouTube) helps amplify the mission to a wider audience.",
      },
      {
        heading: 'Peer-to-Peer Fundraisers',
        text: 'Supporters can initiate community or birthday fundraisers within their personal and professional networks to rally financial backing for the children.',
      },
    ],
  },
  {
    title: '8. Support for USA and International Supporters',
    items: [
      {
        heading: 'Direct Donations',
        text: "Accepted directly into Snehwan's FCRA foreign account.",
      },
      {
        heading: 'Benevity Matching & Volunteering',
        text: 'Use the Benevity platform to seamlessly match your monetary contributions and book your volunteering hours for Snehwan.',
      },
      {
        heading: 'USA Tax Benefits',
        text: 'For specific details regarding USA tax benefits, please reach out directly via WhatsApp at +91-8796400484.',
      },
      {
        heading: 'Global Verification',
        text: 'Snehwan is verified by CAF America, Latitude Global, UK Giving, and other international networks.',
      },
    ],
  },
];

const contactInfo = {
  phones: [
    { label: 'Ashok Deshmane', number: '+91 8796400484' },
    { label: 'Snehwan Office', number: '+91 8237277615' },
  ],
  email: 'snehwan@yahoo.in',
  address:
    'Snehwan, Near Koyali Phata, Koyali tarfe Chakan, Taluka Khed, District Pune, Maharashtra - 410501',
};

// ---- Inline style objects (using the site's CSS variables) ----
const styles = {
  wrapper: {
    width: '80%',
    margin: '3rem auto',
    fontFamily: 'inherit',
  },
  mainTitle: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: 700,
    color: 'var(--heading)',
    marginBottom: '1.5rem',
  },
  intro: {
    textAlign: 'center',
    fontSize: '1.05rem',
    lineHeight: 1.7,
    color: 'var(--nav-letter)',
    maxWidth: '900px',
    margin: '0 auto 2.5rem auto',
  },
  introHighlight: {
    color: 'var(--readmore)',
    fontWeight: 600,
  },
  section: {
    marginBottom: '2rem',
    padding: '1.5rem 1.75rem',
    borderRadius: '12px',
    backgroundColor: 'var(--sub_background)',
    border: '1px solid var(--border_color)',
    borderLeft: '4px solid var(--nav-border)',
  },
  sectionTitle: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: 'var(--heading)',
    marginBottom: '1rem',
    borderBottom: '2px solid var(--nav-border)',
    paddingBottom: '0.5rem',
    display: 'inline-block',
  },
  itemList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  item: {
    marginBottom: '1rem',
    lineHeight: 1.6,
  },
  itemHeading: {
    fontWeight: 600,
    color: 'var(--readmore)',
    marginRight: '0.4rem',
  },
  itemText: {
    color: 'var(--nav-letter)',
    fontSize: '0.98rem',
  },
  contactSection: {
    marginTop: '2.5rem',
    padding: '1.75rem',
    borderRadius: '12px',
    backgroundColor: 'var(--heading)',
    border: '1px solid var(--nav-border)',
  },
  contactTitle: {
    fontSize: '1.3rem',
    fontWeight: 700,
    marginBottom: '1rem',
    color: 'var(--info-numbers)',
  },
  contactRow: {
    marginBottom: '0.5rem',
    fontSize: '0.98rem',
    lineHeight: 1.6,
    color: 'var(--info-numbers)',
  },
};

// Reusable block for one section (title + list of items)
const DonationSection = ({ title, items }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    <ul style={styles.itemList}>
      {items.map((item, idx) => (
        <li key={idx} style={styles.item}>
          <span style={styles.itemHeading}>{item.heading}:</span>
          <span style={styles.itemText}>{item.text}</span>
        </li>
      ))}
    </ul>
  </div>
);

const DonationWays = () => {
  return (
    <div style={styles.wrapper}>
      <p style={styles.intro}>
        Supporting Snehwan—a non-profit organization dedicated to providing{' '}
        <span style={styles.introHighlight}>
          shelter, nutrition, quality education, and skill development
        </span>{' '}
        to the children of distressed farmers, farm laborers, and marginalized
        communities—makes a profound difference in transforming lives.
      </p>

      <h2 style={styles.mainTitle}>Ways You Can Support Snehwan</h2>
      <p style={styles.intro}>
        Here are the primary ways individuals and organizations can support
        Snehwan's mission:
      </p>

      {donationSections.map((section, idx) => (
        <DonationSection key={idx} title={section.title} items={section.items} />
      ))}

      <div style={styles.contactSection}>
        <h3 style={styles.contactTitle}>Get in Touch</h3>
        <p style={styles.contactRow}>
          To coordinate contributions, plan a volunteer visit, or explore partnership
          opportunities, you can reach out directly:
        </p>
        {contactInfo.phones.map((p, idx) => (
          <p key={idx} style={styles.contactRow}>
            Phone: {p.number} ({p.label})
          </p>
        ))}
        <p style={styles.contactRow}>Email: {contactInfo.email}</p>
        <p style={styles.contactRow}>Address: {contactInfo.address}</p>
      </div>
    </div>
  );
};

export default DonationWays;